import { c as _c } from "react/compiler-runtime";
import { QueryParams } from "@router/route-params";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
/**
 * Generic hook for managing a sorting parameter in the URL
 */
export function useSortingQueryParam(t0) {
  const $ = _c(17);
  const {
    defaultSort,
    isValidSort
  } = t0;
  const [searchParams, setSearchParams] = useSearchParams();
  const hasReadSortQueryParam = useRef(false);
  let t1;
  bb0: {
    let t2;
    let urlSortBy;
    if ($[0] !== isValidSort || $[1] !== searchParams) {
      urlSortBy = searchParams.get(QueryParams.sortBy);
      t2 = isValidSort(urlSortBy);
      $[0] = isValidSort;
      $[1] = searchParams;
      $[2] = t2;
      $[3] = urlSortBy;
    } else {
      t2 = $[2];
      urlSortBy = $[3];
    }
    if (t2) {
      t1 = urlSortBy;
      break bb0;
    }
    t1 = defaultSort;
  }
  const newSortBy = t1;
  const [sortBy, setSortBy] = useState(newSortBy);
  let t2;
  if ($[4] !== searchParams || $[5] !== setSearchParams) {
    t2 = newSortBy_0 => {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.set(QueryParams.sortBy, newSortBy_0);
      setSearchParams(newSearchParams, {
        replace: true
      });
    };
    $[4] = searchParams;
    $[5] = setSearchParams;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const setNewSortBy = t2;
  let t3;
  let t4;
  if ($[7] !== newSortBy) {
    t3 = () => {
      if (!hasReadSortQueryParam.current) {
        hasReadSortQueryParam.current = true;
        setSortBy(newSortBy);
      }
    };
    t4 = [newSortBy];
    $[7] = newSortBy;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[10] !== newSortBy || $[11] !== setNewSortBy || $[12] !== sortBy) {
    t5 = () => {
      if (!hasReadSortQueryParam.current) {
        return;
      }
      if (sortBy !== newSortBy) {
        setNewSortBy(sortBy);
      }
    };
    t6 = [sortBy, newSortBy, setNewSortBy];
    $[10] = newSortBy;
    $[11] = setNewSortBy;
    $[12] = sortBy;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  useEffect(t5, t6);
  let t7;
  if ($[15] !== sortBy) {
    t7 = {
      sortBy,
      setSortBy
    };
    $[15] = sortBy;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}